module.exports = __webpack_public_path__ + "static/media/SimpleBadOptimized.15181277.webp";